import { useState } from 'react';
import SearchUserForm from '../../../components/forms/admin/search-user.form';
import { Grid, Typography } from '@mui/material';
import { searchUser } from '../../../services/account.service';
import { SearchUserFormDto } from '../../../services/dtos/form/search-user-form.dto';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import SearchUserTable from '../../../components/table/admin/search-user/search-user.table';
import { UserAdminPaginationDto } from '../../../services/dtos/user-admin-pagination.dto';
import LinearProgress from '@mui/material/LinearProgress';
import { useConfirm } from 'material-ui-confirm';
import { useAuth } from '../../../hooks/use-auth.hook';

/**
 * Page de moteur de recherche
 * @constructor
 */
export default function SearchUserPage() {
    //AuthContext
    let auth = useAuth();
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    //Use confirm dialog
    const confirm = useConfirm();
    //UseState
    const [page, setPage] = useState<number>(0);
    const [searching, setSearching] = useState<boolean>(false);
    const [showSearchUser, setShowSearchUser] = useState<boolean>(true);
    const [users, setUsers] = useState<UserAdminPaginationDto>();
    const [form, setForm] = useState<SearchUserFormDto>();

    //On envoi le formulaire pour récupérer les données
    const handleSumbitForm = (formParam: SearchUserFormDto) => {
        setSearching(true);
        //On met à jour le numéro de page
        formParam.page = page + 1;
        sendForm(formParam);
    };

    //Permet de switch de formulaire
    const handleChangeSwitch = () => {
        setShowSearchUser(!showSearchUser);
    };

    //Permet de changer de page
    const handleSwitchPageNumber = (pageNumber: number) => {
        setPage(pageNumber);
        //On met à jour le numéro de page
        if (form) {
            form.page = pageNumber + 1;
            sendForm(form);
        }
    };

    //fonction pour envoyer le formulaire
    const sendForm = (formParam: SearchUserFormDto) => {
        setSearching(true);
        searchUser(formParam)
            .then(result => {
                //Changement d'état lors d'un succès du form et des users
                setForm(formParam);
                setUsers(result);
            })
            .catch(error => {
                //Affichage d'error
                console.error("Erreur lors de la recherche d'abonné");
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                //Fin recherche
                setSearching(false);
            });
    };

    //Permet de changer de page
    const handlerLoggedInAs = (id: string, name: string, firstName: string) => {
        confirm({
            title: 'Êtes-vous certain de vouloir effectuer cette action ?',
            description: 'Vous allez vous connecter en tant que : ' + name + ' ' + firstName,
            cancellationText: 'Annuler',
        })
            .then(() => {
                auth.loggedInAs(id, name, firstName);
            })
            .catch(() => showMessage.errorAlert('Erreur lors de la connexion en tant que'));
    };

    //Affichage de la page
    return (
        <>
            <Typography variant="h5">Recherche d'abonné</Typography>
            <Grid container spacing={2} direction="column">
                {/*Formualire de recherche*/}
                <Grid item>
                    <SearchUserForm
                        handleSumbitForm={handleSumbitForm}
                        searching={searching}
                        showSearchUser={showSearchUser}
                        handleChangeSwitch={handleChangeSwitch}
                    />
                </Grid>
                {/*resultat de la recherche*/}
                <Grid item>
                    {users && (
                        <SearchUserTable
                            users={users}
                            isSearching={searching}
                            handleSwitchPageNumber={handleSwitchPageNumber}
                            page={page}
                            handlerLoggedInAs={handlerLoggedInAs}
                        />
                    )}
                    {/*Loadin en attendant lors de la première recherche*/}
                    {!users && searching && <LinearProgress />}
                </Grid>
            </Grid>
        </>
    );
}
